import COLORS from '../../../../resources/style/Themes';
import { VOLTAGE_DISTANCE_DATA } from './voltageDistanceData';
import VoltageSource from '../../../../resources/images/alerts_visualizer_images/voltage_source.png';
import VoltageFirstAlertImage from '../../../../resources/images/alerts_visualizer_images/voltage_first_alert.png';
import VoltageMaxAlertImage from '../../../../resources/images/alerts_visualizer_images/voltage_max_alert.png';
import AlertDistanceVisualizerBase from './AlertDistanceVisualizerBase';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '@/resources/strings/StringKeys';
import type { SxProps, Theme } from '@mui/material';

const DEFAULT_VOLTAGE = '17.3kV Phase-Phase / 10kV Phase-Neutral';
const DEFAULT_SENSITIVITY = 10;

interface VoltageDistanceVisualizerProps {
  initialType?: string;
  initialSensitivity?: number;
  hoveredSensitivity?: number;
  sx?: SxProps<Theme>;
}

export default function VoltageDistanceVisualizer({
  initialType = DEFAULT_VOLTAGE,
  initialSensitivity = DEFAULT_SENSITIVITY,
  hoveredSensitivity,
  sx,
}: VoltageDistanceVisualizerProps) {
  const { t } = useTranslation();

  return (
    <AlertDistanceVisualizerBase
      variant="voltage"
      title={t(StringKeys.VOLTAGE_ALERTS_VISUALIZER)}
      description={t(StringKeys.VOLTAGE_ALERTS_VISUALIZER_DESCRIPTION)}
      alertColor={COLORS.SAFEGUARD_ORANGE}
      sourceImage={VoltageSource}
      firstAlertImage={VoltageFirstAlertImage}
      maxAlertImage={VoltageMaxAlertImage}
      dataSource={VOLTAGE_DISTANCE_DATA}
      initialType={initialType}
      initialSensitivity={initialSensitivity}
      hoveredSensitivity={hoveredSensitivity}
      sx={sx}
    />
  );
}
